import { Minus, Plus } from "lucide-react";

export const QuantityStepper = ({ value, min = 1, max = 99, onChange, testid = "qty" }) => {
  const dec = () => onChange(Math.max(min, value - 1));
  const inc = () => onChange(Math.min(max, value + 1));
  return (
    <div className="inline-flex items-center border border-jow-navy/20" data-testid={testid}>
      <button
        type="button"
        onClick={dec}
        className="w-9 h-10 flex items-center justify-center text-jow-navy hover:bg-jow-navy hover:text-jow-cream transition"
        data-testid={`${testid}-dec`}
        aria-label="Decrease"
      >
        <Minus size={14} />
      </button>
      <span
        className="min-w-[2.25rem] text-center font-sans text-sm text-jow-navy"
        data-testid={`${testid}-value`}
      >
        {value}
      </span>
      <button
        type="button"
        onClick={inc}
        className="w-9 h-10 flex items-center justify-center text-jow-navy hover:bg-jow-navy hover:text-jow-cream transition"
        data-testid={`${testid}-inc`}
        aria-label="Increase"
      >
        <Plus size={14} />
      </button>
    </div>
  );
};
